// extracted by mini-css-extract-plugin
module.exports = {"ModalFull":"components-base-ModalFull-ModalFull__ModalFull--Sbk-F"};